export default {"src":"/_next/static/image/public/images/legends_bg.9c9eee71bedc7d6ccfed07666bd58b3e.svg","height":114,"width":467};